import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'icc-redirect',
  template: ``,
  styles: [
  ]
})
export class RedirectComponent {

  constructor(
    route: ActivatedRoute,
  ) {
    window.location.href = route.snapshot.data.externalUrl + '?redirect=' + window.location.pathname;
  }
}
